import { FC, PropsWithChildren } from 'react';
import { GhostTriggerButton } from '../TriggerButton';

type Props = {
  onClick: () => void;
};

export const ConditionCastTypeTrigger: FC<PropsWithChildren<Props>> = ({ children, onClick }) => {
  return <GhostTriggerButton onClick={onClick}>{children}</GhostTriggerButton>;
};
